import { render, staticRenderFns } from "./PayAnyone.vue?vue&type=template&id=2abcf6e4&scoped=true&"
import script from "./PayAnyone.vue?vue&type=script&lang=js&"
export * from "./PayAnyone.vue?vue&type=script&lang=js&"
import style0 from "./PayAnyone.vue?vue&type=style&index=0&id=2abcf6e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abcf6e4",
  null
  
)

export default component.exports